// extracted by mini-css-extract-plugin
module.exports = {"container":"Frequentation_container__11kTH"};